module.exports = __webpack_public_path__ + "img/location-qingdao.4acd168d.png";